






































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Logger } from 'aws-amplify';
import * as rules from '@/rules';

// Logger.LOG_LEVEL = "DEBUG";
const logger = new Logger("EditableField.vue");

@Component({
    // Need this empty components object for the Amplify Logger
    components: {},
})

export default class EditableField extends Vue {

    @Prop()
    label!: string;

    @Prop()
    value!: string;

    @Prop({default: 'text'})
    type!: string;

    @Prop()
    editable!: boolean;

    private fieldValue: string = '';
    private editing: boolean = false;

    private rules = {
        required: rules.REQUIRED,
        emailFormat: rules.EMAIL_FORMAT,
        phoneFormat: rules.PHONE_FORMAT,
    }

    mounted() {
        if (this.type === 'phone') {
            this.fieldValue = this.value.substring(2);
        } else {
            this.fieldValue = this.value;
        }
    }

    @Watch('value')
    valueChanged() {
        if (this.type === 'phone') {
            this.fieldValue = this.value.substring(2);
        } else {
            this.fieldValue = this.value;
        }
        this.editing = false;
    }

    private isDisabled() {
        if (this.type === 'phone' && this.fieldValue.length != 14) {
            return true;
        }
        if (this.type === 'text' && this.fieldValue == '') {
            return true;
        }
        return false;
    }

    private cancel() {
        this.valueChanged();
        // need to force a re-render from the parent due to v-mask in phone # not re-rendering correctly
        // TODO - Find better method of forcing a re-render of the phone # input on cancel() (2020-05-28)
        this.$emit('cancel');
    }

    private save() {
        if (!this.isDisabled()) {
            let payload: string = '';
            if (this.type === 'phone') {
                payload = '+1' + this.fieldValue.replace(/\D/g, '');
            } else {
                payload = this.fieldValue;
            }
            this.$emit('input', payload);
            this.$emit('field-changed', payload);
            this.editing = false;
        }
    }

}
